// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"bacc90aa","21":"d7e2653b","83":"3be5f824","150":"a95570fb","323":"612f79fe","335":"41f2fb30","453":"056bf105","505":"c8b50e6f","630":"9fd28aac","669":"c33ef2a6","731":"3a5a4a3a","791":"63c75922","937":"4daccf12"}[chunkId] + ".chunk.js";
};